import React from 'react';

import { createNewRequest } from '../../constants/factory';

import RequestData from '../../data/requests';
import SearchResult from '../SearchResult/SearchResult';

class NewOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchResult: {},
            justSubmitted: false
        };
        this.handleAddRequest = this.handleAddRequest.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.renderSubmittedMessage = this.renderSubmittedMessage.bind(this);
    }

    handleAddRequest(e) {
        e.preventDefault();
        const {currentUser, addNewRequest} = this.props;
        const {advocate, justification} = this.refs;
        const advocateId = advocate.options[advocate.selectedIndex].value;

        const newRequest = createNewRequest(currentUser.userId, advocateId, justification.value, this.state.searchResult);
        this.state = {
            searchResult: {},
            justSubmitted: true
        };
        addNewRequest(newRequest);
    }

    handleSearch(e) {
        e.preventDefault();
        this.setState({
            searchResult: RequestData().requests[9].bookInfo,
            justSubmitted: false
        });
    }

    renderSubmittedMessage() {
        if (this.state.justSubmitted) {
            return (
                <p>Request Submitted!</p>
            )
        }
    }

    render() {
        const {permissions, users, currentUser} = this.props;
        const renderSearchResult = () => {
            if (Object.keys(this.state.searchResult).length > 0) {
                return (
                    <div>
                        {/*{this.renderSubmittedMessage.bind(null)}*/}
                        <SearchResult {...this.state} />
                        <form className="search-form" ref="searchForm" onSubmit={this.handleAddRequest}>
                            Associate Advocate:
                            <select className="associate-advocate" name="Associate Advocate" ref="advocate">
                                {permissions.associateAdvocates.map((advocate, i) => {
                                    return (
                                        <option value={advocate} key={i}>{users.find((user) => {
                                            return user.userId === advocate;
                                        }).userName.first}</option>
                                    );
                                })}
                            </select>
                            <input className="justification" type="text" ref="justification"
                                   placeholder="Enter justification for request" required/>
                            <input className="submit" type="submit"/>
                        </form>
                    </div>
                );
            }
        };

        return (
            <div className="new-request-page">
                <h1>Submit New Book Request</h1>
                <hr />
                <form className="search-form" ref="searchForm" onSubmit={this.handleSearch}>
                    <input type="text" ref="searchText" placeholder="Enter an ISBN"/>
                    <input type="submit" hidden/>
                </form>
                {renderSearchResult()}
            </div>
        );
    }
}


export default NewOrder;



/** WEBPACK FOOTER **
 ** ./src/components/NewOrder/NewOrder.js
 **/